import { render, staticRenderFns } from "./enterCodePage.vue?vue&type=template&id=a2026654&scoped=true"
import script from "./enterCodePage.vue?vue&type=script&lang=js"
export * from "./enterCodePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2026654",
  null
  
)

export default component.exports